import { Form, Select } from 'antd'
import { FC } from 'react'
import { CustomFormInstance } from '../../../../types'
import { MachineForm, MachineNames, ManufactureForm } from '../types'

type Props = {
    form: CustomFormInstance<MachineForm> | CustomFormInstance<ManufactureForm>
}

const ComponentsForCharacteristics: FC<Props> = ({ form }) => {
    const primaryComponents =
        (form.getFieldValue(
            MachineNames.primaryComponents
        ) as MachineForm['primaryComponents']) ?? []

    return (
        <Form.Item name="componentsForCharacteristics">
            <Select
                mode="multiple"
                options={primaryComponents.map((item) => ({
                    value: item.id ?? '',
                    label: item.component,
                }))}
            />
        </Form.Item>
    )
}

export default ComponentsForCharacteristics
